import { RightSectionTranslations } from './types';

export const enTranslations: RightSectionTranslations = {
    selectStatement: "Select a disease to view more information"
};